<template>
  <div class="partner-contact-bd">
    <div class="partner-contact-wrap">
      <div class="table-bd">
        <custom-table
          :data="contactList"
          :loading="isLoading"
          :column="tableColumn"
          @filter="filterChange"
          @sort="sortChange"
        >
        </custom-table>
      </div>
    </div>

  </div>
</template>

<script>
import apis from '@/utils/apis';

export default {
  components: {},
  props: {
    data: {
      type: Object,
      default() {
        return {};
      }
    },
    partnerId: String,
    partnerOrgId: String,

  },
  data() {
    return {
      tableCode: 'company_salesman',
      // 合同类型
      // 操作
      visibleSet: '',
      dialogSetData: {},
      contactList: [],
    };
  },

  mounted() {
    this.getTableColumn();
    this.getContactList();
    this.getFuncView('/customer/renterDetail');
  },
  methods: {
    getContactList: function () {
      if (!this.partnerOrgId) {
        return;
      }
      this.$getJSON(apis.UserList4Role, {
        orgId: this.partnerOrgId,
        roleCode: 'SYS_ROLE_SM'
      }).then((res) => {
        this.contactList = res.data;
      });
    },

  }
};
</script>

<style lang="scss">
@import "style/colors.scss";
.partner-contact-bd {
  // height: 100%;
  // display: flex;
  // flex-direction: column;
  .partner-contact-wrap {
    // flex: 1;
    // height: 0;
    // display: flex;
    // flex-direction: column;
    padding: 0 10px;
    margin: 10px;
    // background-color: #ffffff;
    .morebtn {
      color: $main-color;
    }
  }
}
</style>
